import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { SharedService, ShowMessageBaseService } from './';

@Injectable({ providedIn: 'root' })
export class RequestErrorHandlerService {
  private readonly sharedService = inject(SharedService);
  private readonly router = inject(Router);
  private readonly messageBaseService = inject(ShowMessageBaseService);

  defaultErrorHandler = (error: HttpErrorResponse, errorRoute: string): Observable<never> => {
    this.navigateWhenError(error, errorRoute);
    return throwError(() => error);
  };

  private navigateWhenError(err: HttpErrorResponse, errorRoute: string): void {
    if (err.status === 0 || err.status === 400) {
      this.sharedService.setError(err);
      this.router
        .navigate([errorRoute])
        .then(() => console.error('navigate to error page'))
        .catch(console.error);
    } else {
      this.messageBaseService.defaultErrorMessage('unbekannter fehler', JSON.stringify(err));
    }
  }
}
